export const CONSENT_METHOD_APPROVED = 'approved';
export const CONSENT_METHOD_DENIED = 'denied';
export const CONSENT_METHOD_USED_SETTINGS = 'settings';
